// ----------------------------------------------------------------------------
// Snippet: Free Shipping Progress
// ----------------------------------------------------------------------------

import $ from 'jquery';
import { formatMoney } from '@shopify/theme-currency';
import { lineItemCardHtml } from '../sections/ajax-add-cart';
import { cartSubtotalUpdate } from '../sections/ajax-add-cart';

Shopify.miniCart = (function($){

    var _config = {
        itemsContainerSelector : '.mini-cart__items-container',
        itemsListSelector      : '.mini-cart__items-list',
        miniCartFooterSelector : '.mini-cart__footer',
        shopifyAjaxCartURL     : '/cart.js',
    };

    var _init = function(){

        $(document).ready(function(){

            var $itemsContainer  = $(_config.itemsContainerSelector),
                $itemsList       = $(_config.itemsListSelector);

            // Update cart count and cart modal.
            $.ajax({
                url: _config.shopifyAjaxCartURL,
                cache: false,
                dataType: "json",
                success: function(cart) {
                
                if ( $itemsContainer.length ) { // If the mini cart is being used, then update the mini cart.
                    if (cart.items.length) {

                        $itemsList.empty();
                        $.each(cart.items, function(index, value){// loop through each line items in cart
                            var $lineItemCardHtml = lineItemCardHtml(value);
                            if ( $itemsList.length ) {
                                $itemsList.append('<li class="mini-cart__line-item">'+ $lineItemCardHtml +'</li>');
                            }
                        })
                    }else{
                        $itemsList.empty();
                        $itemsList.append('<li class="mini-cart__line-item">There are no items in the cart</li>')
                    }
                }

                // Update cart subtotal and items amount (in mini cart, add to cart confirmation modal, and cart page)
                cartSubtotalUpdate(cart);
            }});
        })
    }
    return {
        init: function(params) {
                // Configuration
                params = params || {};
                // Merging with defaults.
                $.extend(_config, params);
                // Action
                $(function() {
                    _init();
                });
        },
        getConfig: function() {
            return _config;
        }
    }
})($)

Shopify.miniCart.init();
